import { ChangeDetectorRef, Component, inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { HTTPService } from 'src/app/services/http.service';
import { LanguageServices } from 'src/app/services/LanguageServices';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { CardView } from 'src/app/interfaces/cardview';
import { from, mergeMap, Subject, Subscription, toArray } from 'rxjs';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { NzUploadChangeParam, NzUploadFile, NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { UploadServices } from 'src/app/services/upload.services';
import { HttpEventType } from '@angular/common/http';

@Component({
  selector: 'app-json-importer',  
  templateUrl: './json-importer.component.html',
  styleUrl: './json-importer.component.scss',
  standalone: false
})
export class JsonImporterComponent implements OnInit{
  
  
  
    @ViewChild('datagridCfg') datagridCfg;
  
    jsonStructure: any;
    mappingConfig: any;
    idUser:any;
    configJson:any;
    rows:any;
    
     
    codecompany:Number; 
    codecontract:Number;
    
    conditionImp:string = '0=1';
    conditionImpLog:string = '0=1';
    conditionCfg:string = '0=1';
  
    tableName: string = "Selecione uma configuração xxx.";
    idRule: string;
    configVisibility:string;
    headerText:string;
    updaloadDirectory = false;
    loadingDirectory = false;
    directoryPath=null;
    directoryfileList:File[] = [];
    
    eventsSubject: Subject<string> = new Subject<string>();  
  
    activecompanies:Object;
  
    parentRow:CardView;
  
    dparaConfig: any = {};
  
    visibilityOptions = [
    { value: 'O', label: 'Pública' },
    { value: 'C', label: 'Privada' }
    ];

    configs: any[] = [];
    loadingConfigs = false;
    @ViewChild('inputDialog') inputDialog!: TemplateRef<any>;
    dialogRef: NzModalRef<any> | null = null;
    parametrosDialog: any[] = [];
    fileList:any[] = [];
    sub1:Subscription;

    private updLoad:UploadServices = inject(UploadServices);
  
    constructor(private sanitizer: DomSanitizer, public modal: NzModalService,public http:HTTPService,public uas:UserAuthenticationServices,
      private snackServices:SnackbarService,private cdRef: ChangeDetectorRef, private ls: LanguageServices) {

    }

    ngOnDestroy(){
      
      if ( this.fileList != null ){
        this.fileList = [];
      }

      if ( this.fileListZorro != null){
        this.fileListZorro = [];
      }

      this.http.stopSubscription();

      if ( this.sub1 != null){ this.sub1.unsubscribe(); }
    }


    validateAndSubmit() {
        const params = this.parametrosDialog;

        if (!params) return;

        const invalid = params.some((p: any) =>( (p.TYPE === 'I' && (!p.VALUE || p.VALUE.trim() === '')) || ( p.TYPE === 'S'  && (!p.VALUE || p.VALUE === null || p.VALUE.key === null || p.VALUE.key === '') )  || (p.TYPE ==='D' && this.fileList.length === 0 && this.directoryfileList.length ===0) ));
        
        if (invalid) {
          throw Error(this.ls.instant('jsonimporter.fillRequired'));
        }

        this.dialogRef?.close({ parameters: params });
    }

    closeDialog() {
      this.ngOnDestroy();
      this.dialogRef?.close();
    }

    loadConfigs() {

      if(this.codecompany){

        this.configs = [];
        this.loadingConfigs = true;

        const obinfo = {
        entityName: 'Mktpjsonrule',
        condition: ` CODECOMPANY=${this.codecompany}  OR VISIBILITY = 'O'`,
        showImageData: true,
        showImageDataBase64: true
        }



        this.http.post(obinfo, 'JsonBrokerServices/find', false, true, true).subscribe({
          next: conInfo => {

          let registros = conInfo['Mktpjsonrule'] || [];
          for (let reg of registros) {

            // RULEJSON invalido/nulo nao pode derrubar a lista inteira
            let jsonConfig: any;
            try {
              jsonConfig = JSON.parse(reg['RULEJSON']);
            } catch (e) {
              console.error('RULEJSON invalido para a configuracao:', reg['NAME'], e);
              continue;
            }

            const configObj: {
                NAME: string;
                IMAGE: SafeUrl; // <- aqui!
                parameters: any;
                config: any;
                fullConfig: any;
                status: string;
                duration: any;
                errorMsg: string;
              } = {
                NAME: reg['NAME'],
                IMAGE: '', // inicializa vazio (ou com `null`)
                parameters: jsonConfig.parameters,
                config: jsonConfig.config,
                fullConfig: jsonConfig,
                status: 'idle',
                duration: null,
                errorMsg: ''
              };

            if ( ObjectUtil.isNotEmpty(reg['IMGCONFIG'])){

              let objectURL = 'data:image/png;base64,' + reg['IMGCONFIG'];
              configObj.IMAGE = this.sanitizer.bypassSecurityTrustUrl(objectURL);
            }


            this.configs.push(configObj);
          }
          this.loadingConfigs = false;
          this.cdRef.detectChanges();
          },
          error: err => {
            this.loadingConfigs = false;
            this.cdRef.detectChanges();
            throw err;
          }
        });
      }
  }

  copyToClipboard(text: string): void {
    navigator.clipboard.writeText(text).then(() => {
      this.snackServices.showSuccess(this.ls.instant('jsonimporter.errorCopied'));
    }).catch(err => {
      console.error('Erro ao copiar texto:', err);
    });
  }
  

  processarArquivos(conf: any) {
    const concurrency = 10;
    from(this.directoryfileList).pipe(
        mergeMap(async (file, index) => {

          // 1) Clona o conf para este worker
          const workerConf = structuredClone(conf);

          // 2) Cada worker mantém sua própria lista local
          
          // 3) Upload retorna o arquivo processado
          const uploaded:any[] = await this.updloadFile(file);
          if ( uploaded == null || uploaded.length ==0 ){
              console.log(`Arquivo ${file.name} não foi carregado.`);
          }else{
                // 5) Atualiza SOMENTE o conf deste worker
              workerConf.config.parameters
                ?.filter((p: any) => p.TYPE === 'D')
                .map((p: any) => p.VALUE = uploaded);

              // 6) Executa o import isolado
              await this.executeImport(workerConf, index);
          }
          
          

        }, concurrency ), 
        toArray()
      ).subscribe(statusBuffer => {
        console.log("Processamento finalizado", statusBuffer);
      });

}

  async onExecute(conf: any) {
    const inputParams = conf.config.parameters?.filter((p: any) => p.TYPE === 'I' ||  p.TYPE === 'D'|| p.TYPE === 'S' );
    conf.config.parameters?.filter((p: any) => p.TYPE === 'D' ).map((p: any) => p.VALUE = this.fileList );
    conf.isDirectoryUpload = this.updaloadDirectory;
    
    if (inputParams?.length > 0) {

      this.parametrosDialog = inputParams;


      this.dialogRef = this.modal.create({
        nzContent: this.inputDialog,
        nzData: { parameters: inputParams },
        nzFooter: null,
        nzClosable: false,
        nzWidth: '90vw',
        nzStyle: { top: '40px' },
        nzMaskClosable: true,
        nzKeyboard: true
      });

      this.dialogRef.afterClose.subscribe(async result => {
          if (result) {
            conf.parameters = result.parameters;


             if ( this.directoryfileList != null && this.directoryfileList.length > 0 ){ 
            //   let i = 0;
            //   let statusBuffer = [];
            //   for ( let file of this.directoryfileList ){
            //     await this.updloadFile(file);
            //     conf.config.parameters?.filter((p: any) => p.TYPE === 'D' ).map((p: any) => p.VALUE = this.fileList );
      
            //     await this.executeImport(conf,i, statusBuffer);
            //     i++;
            //   }
            //   console.log(statusBuffer);  
              this.processarArquivos(conf);

            }else{
              this.executeImport(conf);
            }


            
          // this.executeImport({ ...conf, parameters: result.parameters });
          }
        this.dialogRef = null;
      });
    } else {
      this.executeImport(conf);
    }
  }

  
  isMultiline(value: string): boolean {
    return value?.length > 60 || value?.includes('\n') || value?.includes('{') || value?.includes('[');
  }

  executeImport(confWithValues: any, indexFile:number = -1, statusBuffer:string[]=[]): Promise<void> {

    return new Promise<void>((resolve, reject) => {
        const configPayload = confWithValues;

        confWithValues.status = 'processing';
        confWithValues.startTime = Date.now();
        confWithValues.duration = null;
        confWithValues.errorMsg = '';


        this.headerText = confWithValues["NAME"] + " - " + this.ls.instant('jsonimporter.statusProcessing');

        this.cdRef.detectChanges();

        this.http.post(configPayload, 'impExp/saveJSON', false, true, false).subscribe({
          next: (data: any) => {
            const duration = (Date.now() - confWithValues.startTime) / 1000;
            confWithValues.duration = duration.toFixed(2);

            // Caso 2 - Retorno com statusRequest indicando erro
            if (data?.statusRequest === '2') {
              confWithValues.status = 'error';
              confWithValues.errorMsg = data?.message || this.ls.instant('jsonimporter.apiError');

              this.headerText = confWithValues["NAME"] + " - " + this.ls.instant('jsonimporter.statusError');
              if ( indexFile > -1 ){
                statusBuffer.push(`Arquivo: ${this.directoryfileList[indexFile].name} - Erro: ${confWithValues.errorMsg}`);
              }else{
                this.snackServices.showError(confWithValues.errorMsg);
              }
              

            // Caso 1 e 3 - Verifica se há dados em resultado.data
            } else if (data?.resultado?.data?.length > 0) {
              confWithValues.status = 'success';
              this.headerText = confWithValues["NAME"] + " - " + this.ls.instant('jsonimporter.statusSuccess');


              if ( indexFile > -1 ){
                statusBuffer.push(`Arquivo: ${this.directoryfileList[indexFile].name} - ${this.ls.instant('jsonimporter.successMsg')}`);
              }else{
                this.snackServices.showSuccess(this.ls.instant('jsonimporter.successMsg'));
              }

            } else {
              confWithValues.status = 'error';
              this.headerText = confWithValues["NAME"] + " - " + this.ls.instant('jsonimporter.statusError');
              confWithValues.errorMsg = this.ls.instant('jsonimporter.emptyResponse');
              if ( indexFile > -1 ){
                statusBuffer.push(`Arquivo: ${this.directoryfileList[indexFile].name} - Erro: Nenhuma ação foi executada. A resposta está vazia.`);
              }else{
                this.snackServices.showError(confWithValues.errorMsg);
                throw Error(confWithValues.errorMsg);
              }

            }

            this.fileListZorro = [];
            this.fileList = [];

            this.cdRef.detectChanges();
            resolve();
          },
          error: (err) => {
            const duration = (Date.now() - confWithValues.startTime) / 1000;
            confWithValues.duration = duration.toFixed(2);
            confWithValues.status = 'error';
            confWithValues.errorMsg = err?.error.message || 'Erro inesperado.';
            this.headerText = confWithValues["NAME"] + " - com erro!";
            this.snackServices.showError(confWithValues.errorMsg);
            this.fileListZorro = [];
            this.fileList = [];
            this.cdRef.detectChanges();
            if ( this.directoryfileList != null && this.directoryfileList.length > 0 && indexFile > -1 ){
              statusBuffer.push(`Arquivo: ${this.directoryfileList[indexFile].name} - Erro: ${confWithValues.errorMsg}`);
              resolve();
            }else{
              throw Error(confWithValues.errorMsg);
            }
            
          }
        });
      });
  }



    ngOnInit(): void { 
    
        if  ( this.uas.user.companylist.length > 1 ){ 
          this.codecompany = null;
          this.codecontract = null;
        }else{
          this.codecompany = Number(this.uas.user.companylist[0].codecompany);
          this.codecontract = Number(this.uas.user.companylist[0].codecontract)              
        }
    
        this.idUser = this.uas.user.iduser;
  
        if(this.codecompany){
          this.conditionCfg = `codecompany=${this.codecompany}`
        }else{
          this.conditionCfg = `1=0`
        }

        this.loadConfigs();
        
        //this.conditionImp = `idUser=${this.idUser} and codecompany=${this.codecompany}`
    
    }
    
    getActiveCompanies(){
          let ob = {
            "entityName":"Mktpactivecompanies",
            "sql":`SELECT A.*
                  FROM MKTPACTIVECOMPANIES A INNER JOIN MKTPCOMPANIES B ON A.CODECOMPANY=B.CODECOMPANY
                  WHERE A.CODECOMPANY=${this.codecompany}            
                  AND A.STATUS=1
                  AND A.ENVIRONMENT=1`
          }
      
          let self = this;
           
          this.http.post(ob,'JsonBrokerServices/findnative',false,true,true).subscribe(con=>{
               
              if( ObjectUtil.isNotEmpty(con['SQL'])){
                this.activecompanies  = con['SQL'][0];                
                
                this.conditionCfg = `codecompany=${this.codecompany}`;                
                this.loadConfigs();

              }else{
                throw Error('Empresa não configurada!');
              }
            });
    }  



    fileListZorro: NzUploadFile[] = [];

    onChange(event: NzUploadChangeParam) {
      this.fileListZorro = event.fileList;
    }

    

    beforeUpload = (file: NzUploadFile): boolean => {
      // if (file.size! > 50 * 1024 * 1024) {
      //   console.error('Arquivo maior que 50MB');
      //   return false;
      // }
      if ( this.updaloadDirectory ){
        this.fileList = [];
        this.fileListZorro = [];
      }
      this.updaloadDirectory =false;


      const nome = file.name.toLowerCase();

      const jaExiste = this.fileListZorro.some(f => f.name.toLowerCase() === nome);

      if (jaExiste) {
        throw Error('O arquivo "' + file.name + '" já foi adicionado.');
      }
      

      return true; // permite o upload multipart automático
    };


    // get valorKey() {
    //   return this.param.VALUE?.key;
    // }

    // set valorKey(v) {
    //   if (!this.param.VALUE) this.param.VALUE = {};
    //   this.param.VALUE.key = v;
    // }

    async openDirectory() {
      const dirHandle = await (window as any).showDirectoryPicker();
      
      this.directoryPath = dirHandle.name;
      this.directoryfileList = [];
      
      if ( this.fileListZorro != null){
        this.fileListZorro = [];
        
      }
      this.updaloadDirectory = true;
      this.loadingDirectory = true;

      for await (const entry of dirHandle.values()) {
        if (entry.kind === 'file') {
          const file = await entry.getFile();
          this.directoryfileList.push(file);
        }
      }
      this.loadingDirectory = false;
      
    }

    
    customUpload = (item: NzUploadXHRArgs) => {
        const formData = new FormData();
        formData.append('file', item.file as any);

        const subProgress = this.updLoad.progress.subscribe(value => {
            const percent = Number(value) || 0;

            const progressEvent: any = {
              type: HttpEventType.UploadProgress,
              loaded: percent,
              total: 100,
              percent
            };

            try {
              item.onProgress?.(progressEvent, item.file!);
            } catch {
              
            }
          });

        this.sub1 = this.updLoad.upLoadFileTempory(formData, true).subscribe({
          next: (event) => {  
            if (event instanceof Array) {
              let ob = event as Object[];
              for (let event of ob as any[]){
                this.fileList.push({
                  NAME: event.fileName,
                  VALUE: event.path,
                  TYPE: 'FILE'
                });
              }
               
              const percent = 100;
              item.onSuccess?.({percent:percent}, item.file!, null as any);
              subProgress.unsubscribe();
            }
          },
          error: (error) => {
            item.onError?.(error, item.file!);
            this.fileListZorro = [];
            this.fileList = [];
            subProgress.unsubscribe();
          },
          complete: () => {
            item.onSuccess?.({}, item.file!,null);
            subProgress.unsubscribe();
          }
        });
      };

      async updloadFile(file):Promise<any[]> {
        let localFileList = [];
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('file', file as any);

            const subProgress = this.updLoad.progress.subscribe(value => {
                const percent = Number(value) || 0;

                const progressEvent: any = {
                  type: HttpEventType.UploadProgress,
                  loaded: percent,
                  total: 100,
                  percent
                };
                  
              });

            this.sub1 = this.updLoad.upLoadFileTempory(formData, true).subscribe({
              next: (event) => {  
                if (event instanceof Array) {
                  let ob = event as Object[];
                  for (let event of ob as any[]){
                    localFileList.push({
                      NAME: event.fileName,
                      VALUE: event.path,
                      TYPE: 'FILE'
                    });
                  }
                  resolve(localFileList);
                }
              },
              error: (error) => {
                resolve([]);
                subProgress.unsubscribe();
              },
              complete: () => {
                subProgress.unsubscribe();
              }
            });
        } );
        
      
      }


    // onFileSelected(event: any, param: any) {
    //   this.fileList = [];
    //   const files: File[] = event.target.files;
      
    //   if (files) {

    //     for (const file of files) {
    //       const reader = new FileReader();
    //       reader.onload = (e: any) => {

    //        const base64 = (reader.result as string).split(',')[1];
            
    //         this.fileList.push({
    //           NAME: file.name,
    //           VALUE: base64,
    //           TYPE: file.type
    //         });
             
    //       };
    //        reader.readAsDataURL(file); 
    //     }
    //   }
    //}
  

}
